import {
    CategoryScale,
    Chart as ChartJS,
    LineElement,
    LinearScale,
    PointElement,
    Tooltip
} from "chart.js";
import moment from 'moment';
import { useContext, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { useMutation } from "react-query";
import Card from "../../../components/Card";
import { InquiryReceivedRes } from "../../../models";
import { httpGET } from "../../../utils/ajaxHelper";
import { StateDashBoardProviderContext } from "../stateDashBoardProvider";
import { IMessageReceivedProps } from "./messageReceived.props";
import { Container } from "./messageReceived.styled";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
);

// Custom options to remove grid lines


export const MessageReceived = ({ comOfferingType, isAllowMobile = true, orgFilter, ...props }: IMessageReceivedProps) => {
    const StateDashBoard = useContext(StateDashBoardProviderContext);

    const monthNames: string[] = [];
    for (let i = 0; i < 12; i++) {
        const monthName = moment().month(i).format('MMM');
        monthNames.push(monthName);
    }

    const [inquiryReceived, setInquiryReceived] = useState<InquiryReceivedRes[]>();
    const { mutate: totalVisitsFetch } = useMutation(
        (type: string) =>
            httpGET({
                url: "/DashboardReport/inquiry-received",
                params: {
                    timeZone: new Date().getTimezoneOffset() / (-60),
                    interval: type,
                    offeringType: comOfferingType?.value,
                    orgId: orgFilter?.value
                }
            }),
        {
            onSuccess: (rs) => {
                setInquiryReceived(rs);
            },
        },
    );

    useEffect(() => {
        // Call when last change
        if (orgFilter?.value) totalVisitsFetch(StateDashBoard!.type);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comOfferingType, orgFilter, StateDashBoard!.type])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    // useEffect(() => { totalVisitsFetch(StateDashBoard!.type) }, [StateDashBoard!.type]);

    if (!inquiryReceived) { return null; }

    const results = monthNames.map(e => {
        return {
            monthName: e,
            count: inquiryReceived.find(f => f.month === e)?.count
        };
    });

    return (
        <Card style={{ height: "100%", width: "100%" }} >
            <Container isAllowMobile={isAllowMobile} >
                <h2 className="mb-[16px]">
                    Inquiries Received
                    <div className="line" />
                    <div className="option" onClick={() => { StateDashBoard!.setType("this_year") }}>
                        <Dot color={StateDashBoard!.type === "this_year" ? "#333333" : "#A8C5DA"} />
                        <span className={!isAllowMobile ? "mb-[16px]" : ""}>
                            This year
                        </span>
                    </div>
                    <div className="option" onClick={() => { StateDashBoard!.setType("last_year") }}>
                        <Dot color={StateDashBoard!.type === "last_year" ? "#333333" : "#A8C5DA"} />
                        <span className={!isAllowMobile ? "mb-[16px]" : ""}>
                            Last year
                        </span>
                    </div>
                    <div className="year">
                        {StateDashBoard!.type === "this_year" ? moment().year() : moment().add(-1, 'y').year()}
                    </div>
                </h2>
                <div className="h-full w-full">
                    {inquiryReceived.length !== 0 ? (<Line
                        style={
                            {
                                height: "100%",
                                width: "100%"
                            }
                        }
                        options={{
                            maintainAspectRatio: false,
                            scales: {
                                x: {
                                    grid: {
                                        display: false,
                                    },
                                },
                                y: {
                                    beginAtZero: true,
                                    grid: {
                                        display: false,
                                    }
                                },
                            },
                            responsive: true,
                        }}
                        data={{
                            labels: results.map(e => e.monthName),
                            datasets: [
                                {
                                    data: results.map(e => e.count),
                                    borderColor: "#939495",
                                    borderWidth: 2,
                                    pointBorderWidth: 0,
                                    tension: 0.1,
                                },
                            ],
                        }}
                    />) : (<div className="no-result h-full">
                        No results found.
                    </div>)}

                </div>
            </Container>
        </Card>
    );
}

const Dot = ({ color }: any) => {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8Z"
            fill={color}
        />
    </svg>
}